import React, { useEffect, useMemo, useState } from "react";
import { Menu } from "@headlessui/react";
import { HiOutlinePlus } from "react-icons/hi";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";
import { useGetAllBankDetailMutation } from "../../../features/tenant/appUserBankDetails/appUserBankApi";
import { getLoginUserData } from "../../../utils/getLoginUserData";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";
import BankDetailManageModal from "../../../components/Tenant/BankList/BankDetailManageModal";
import { hasPermission } from "../../../utils/hasPermission";

const BankList = () => {


  const hasModifyBankAccountPermission = hasPermission("modifyBankAccountList");
  
  const { zone_id: zoneId, zone_name: zoneName } = getLoginUserData();
  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
    .color_shades;
  const [showManageModal, setShowManageModal] = useState(false);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const currentDate = new Date().toISOString().split("T")[0];
  const appUserTypes = JSON.parse(sessionStorage.getItem("appUserType"));
  const [appUsers, setAppUsers] = useState([{
    id: "",
    user_type_id: "",
    user_type: "All",
    name: "All"
  }, ...appUserTypes]);
  const [userTypesArray, setUserTypesArray] = useState({
    id: "",
    user_type_id: "",
    user_type: "All",
    name: "All"
  });
  const [userTypeId, setUserTypeId] = useState(userTypesArray.id);
  const initialRequest = {
    user_type_id: userTypeId,
    limit: 10,
    offset: 0,
    bene_mobile: "",
    startDate: "",
    endDate:"",
  };
  const [request, setRequest] = useState(initialRequest);

  const [
    fetchAllBankDetails,
    {
      data: allBankDetailsData,
      isLoading: allBankDetailsIsLoading,
      isError: allBankDetailsIsError,
      error: allBankDetailsError,
    },
  ] = useGetAllBankDetailMutation();

  const [
    fetchAllBankDetailsCsv,
    {
      data: allBankDetailsCsvData,
      isLoading: allBankDetailsCsvIsLoading,
      isError: allBankDetailsCsvIsError,
      error: allBankDetailsCsvError,
    },
  ] = useGetAllBankDetailMutation();

  const fetchAllBankDetailsFun = () => {
    fetchAllBankDetails({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
    });
  };

  const fetchAllBankDetailsCsvFun = () => {
    const modifiedRequest = {
      ...request,
      limit: null,
      offset: null,
    };
    fetchAllBankDetailsCsv({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: modifiedRequest,
    });
  };


  useMemo(() => {
    for (let index = 0; index < appUsers.length; index++) {
      const element = appUsers[index];
      if (
        element.user_type.toLocaleLowerCase() ===
        userTypesArray?.name?.toLocaleLowerCase()
      ) {
        setUserTypeId(element.user_type_id);
        setRequest((prevRequest) => ({
          ...prevRequest,
          user_type_id: +element.user_type_id,
        }));
        break;
      }
    }
  }, [userTypesArray]);

  useEffect(() => {
    fetchAllBankDetailsFun();
  }, [limit, offset]);
  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
  };

  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "Name",
      cell: (row) => row.bene_name,
      sortable: true,
    },
    {
      name: "Mobile",
      cell: (row) => row.bene_mobile,
      sortable: true,
    },
    {
      name: "Bank Name",
      cell: (row) => row.bene_bank,
      sortable: true,
      minWidth: "200px",
    },

    {
      name: "Bank Account",
      cell: (row) => row?.bene_details?.bank_account,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "IFSC Code",
      cell: (row) => row?.bene_details?.ifsc,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "Upi Id",
      cell: (row) => row?.bene_details?.upi_id,
      sortable: true,
      minWidth: "120px",
    },
  ];
  return (
    <div className="flex w-full bg-gray-200 h-full justify-center">
      <div className="w-full ">
        <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
          Bank List
          <LinksComponent />
        </div>

        <div className="p-3">
        <div className="mb-2">
              <CustomExport
                fetchData={fetchAllBankDetailsCsvFun}
                data={ allBankDetailsCsvData?.body?.bankDetailsList}
                defaultColumnExport={[
                  "bene_name",
                  "bene_mobile",
                  "bene_bank",
                  "bene_details"
                ]}
                filename="bank_list"
              />
            </div>
          <div className=" bg-white shadow rounded-lg ">
            <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
              <div className="flex  space-x-2 ">
                <div className="w-52 searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    From Date
                  </label>
                  <input
                    type="date"
                    value={request.startDate}
                    className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          startDate: newValue,
                        };
                      });
                    }}
                  />
                </div>

                <div className="w-52 searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    End Date
                  </label>
                  <input
                    type="date"
                    className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                    placeholder=""
                    value={request.endDate}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          endDate: newValue,
                        };
                      });
                    }}
                  />
                </div>

                <div className="w-52 ">
                <div className="flex-col slc_dvd topslt">
                <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">User Types</label>
                    <div className="relative searchin">
                    {appUsers && appUsers.length > 0 && (
                      <SelectComponent
                        className="capitalize"
                       // title={"User Types"}
                        selected={userTypesArray}
                        setSelected={setUserTypesArray}
                        dataArr={appUsers}
                      />
                    )}
                  </div></div>
                </div>

                <div className="w-52 searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    Mobile No
                  </label>
                  <input
                    type="text"
                    className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                    placeholder="Enter Mobile No"
                    value={request.bene_mobile}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          bene_mobile: newValue,
                        };
                      });
                    }}
                  />
                </div>

                <div className="w-52 ">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    &nbsp;
                  </label>
                  <button
                    className="btn btn-outline-primary clear-both  pdbtn_all w-full"
                    onClick={() => {
                      fetchAllBankDetailsFun();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>

            <div className=" p-3">
              <div className="p-3 w-full bg-white shadow rounded-lg">
                <DataTableComponent
                  keyField="bene_id"
                  columns={columns}
                  data={
                    allBankDetailsData &&
                    allBankDetailsData.body.bankDetailsList
                  }
                  totalRows={allBankDetailsData?.body?.total_records}
                  handlePerRowsChange={handlePerRowsChange}
                  handlePageChange={handlePageChange}
                  paginationDefaultPage={currentPage}
                  paginationResetDefaultPage={paginationResetToggle}
                ></DataTableComponent>
              </div>
            </div>
          </div>
        </div>

        {hasModifyBankAccountPermission && (
          <div
            className="fixed bottom-0 right-16 w-16 h-16 mr-10 mb-2 cursor-pointer"
            id="box_btn"
          >
            <div className="text-right">
              <Menu className="relative inline-block text-left">
                <div>
                  <Menu.Button
                    onClick={() => setShowManageModal(true)}
                    className="inline-flex justify-cente w-12 h-12 rounded-full text-sm font-medium text-white hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                    style={{ backgroundColor: `${primaryColor["700"]}` }}
                  >
                    <HiOutlinePlus className="w-full h-full p-3" />
                  </Menu.Button>
                </div>
              </Menu>
            </div>
          </div>
        )}

        {showManageModal && hasModifyBankAccountPermission && (
          <BankDetailManageModal
            show={showManageModal}
            setShow={setShowManageModal}
            onSuccess={fetchAllBankDetailsFun}
          />
        )}
      </div>
    </div>
  );
};

export default BankList;
